// Small hook that fetches the backend's public runtime config (payment mode
// flags) exactly once at app boot and caches it in module scope so the UI
// can render a "TEST MODE" badge in payment/checkout surfaces. Automatically
// disappears the moment the operator swaps the sandbox key for a live one —
// no code change required.

import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null;
let inflight = null;

async function loadConfig() {
  if (cached) return cached;
  if (inflight) return inflight;
  inflight = axios.get(`${API}/config`)
    .then((r) => { cached = r.data; return cached; })
    .catch(() => { cached = { paymentEnabled: false, paymentTestMode: false }; return cached; })
    .finally(() => { inflight = null; });
  return inflight;
}

export function usePublicConfig() {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    if (cached) { setCfg(cached); return; }
    let alive = true;
    loadConfig().then((c) => { if (alive) setCfg(c); });
    return () => { alive = false; };
  }, []);
  return cfg || { paymentEnabled: false, paymentTestMode: false };
}
